import { post } from '@alltrails/core/utils/post';
import type { StreetAddressSearchResult } from '@alltrails/types/AlgoliaResults';

const getStreetAddressResults = (query: string, lat?: number, lng?: number) => {
  return post<{ searchResults: StreetAddressSearchResult[] }>('/api/alltrails/locations/search', undefined, { params: { query, lat, lng } });
};

export default getStreetAddressResults;
